import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminGuard } from 'src/app/models/guard/admin.guard';
import { StoreComponent } from './store/store.component';
import { EditStoreComponent } from './store/edit-store/edit-store.component';
import { ListStoreComponent } from './store/list-store/list-store.component';
import { RecordsComponent } from './records/records.component';
import { ListDevicesComponent } from './records/devices/list-devices/list-devices.component';
import { ListRecordsComponent } from './records/list-records/list-records.component';
import { ListGuardComponent } from './records/guards/list-guard/list-guard.component';
import { AdminStoreComponent } from './store/admin-store/admin-store.component';
import { ClientGuard } from 'src/app/models/guard/client.guard';
import { ListFacilityComponent } from './facility/list-facility/list-facility.component';
import { EditFacilityComponent } from './facility/edit-facility/edit-facility.component';
import { SuperGuard } from 'src/app/models/guard/super.guard';
import { ViewFacilityComponent } from './facility/view-facility/view-facility.component';
import { EditScheduledRoundsComponent } from './facility/rounds/scheduled-rounds/edit-scheduled-rounds/edit-scheduled-rounds.component';

const routes: Routes = [
  {
    path: 'instalaciones',
    canActivate: [AdminGuard],
    children: [
      {
        path: 'gestion',
        canActivate: [AdminGuard],
        component: ListFacilityComponent,
        data: {
          title: 'LISTAR',
          breadcrumb: [
            {
              label: 'Instalaciones',
              url: '',
            },
            {
              label: 'Gestión',
              url: '',
            },
          ],
        },
      },
      {
        path: 'editar/:id',
        canActivate: [AdminGuard],
        component: EditFacilityComponent,
        data: {
          title: 'EDITAR',
          breadcrumb: [
            {
              label: 'Instalaciones',
              url: 'control-ingreso/instalaciones/gestion',
            },
            {
              label: 'Editar',
              url: '',
            },
          ],
        },
      },
    ],
  },
  {
    path: 'dependencias',
    canActivate: [AdminGuard],
    component: StoreComponent,
    children: [
      {
        path: 'gestion',
        canActivate: [AdminGuard],
        component: ListStoreComponent,
        data: {
          title: 'LISTAR',
          breadcrumb: [
            {
              label: 'Dependencias',
              url: '',
            },
            {
              label: 'Gestión',
              url: '',
            },
          ],
        },
      },
      {
        path: 'editar/:id',
        canActivate: [AdminGuard],
        component: EditStoreComponent,
        data: {
          title: 'EDITAR',
          breadcrumb: [
            {
              label: 'Dependencias',
              url: 'control-ingreso/dependencias/gestion',
            },
            {
              label: 'Editar',
              url: '',
            },
          ],
        },
      },
    ],
  },
  {
    path: 'registro',
    canActivate: [AdminGuard],
    component: RecordsComponent,
    children: [
      {
        path: 'gestion',
        canActivate: [AdminGuard],
        component: ListRecordsComponent,
        data: {
          title: 'LISTAR',
          breadcrumb: [
            {
              label: 'Control Ingreso',
              url: '',
            },
            {
              label: 'Controles',
              url: '',
            },
          ],
        },
      },
      {
        path: 'dispositivos',
        canActivate: [AdminGuard],
        component: ListDevicesComponent,
        data: {
          title: 'LISTAR',
          breadcrumb: [
            {
              label: 'Control Ingreso',
              url: '',
            },
            {
              label: 'Dispositivos',
              url: '',
            },
          ],
        },
      },
      {
        path: 'guardias',
        canActivate: [AdminGuard],
        component: ListGuardComponent,
        data: {
          title: 'LISTAR',
          breadcrumb: [
            {
              label: 'Control Ingreso',
              url: '',
            },
            {
              label: 'Guardias',
              url: '',
            },
          ],
        },
      },
    ]
  },
  {
    path: 'rondas',
    canActivate: [AdminGuard],
    component: RecordsComponent,
    children: [
      {
        path: 'editar/:id',
        canActivate: [AdminGuard],
        component: EditScheduledRoundsComponent,
        data: {
          title: 'EDITAR',
          breadcrumb: [
            {
              label: 'Instalaciones',
              url: 'control-ingreso/instalaciones/gestion',
            },
            {
              label: 'Editar ronda',
              url: '',
            },
          ],
        },
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EntryControlRoutingModule {}
